import { Autocomplete, Box, Checkbox, Chip, Fade, IconButton, Menu, MenuItem, Switch, TextField, Toolbar, Typography } from "@mui/material";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import { getSelectedProfileSimulate, setSelectedProfileSimulate } from "../../../../redux/selectedProfileSimulateSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import SaveIcon from '@mui/icons-material/Save';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { getSimulatorProfiles } from "../../../../redux/simulatorProfilesSlice";
import { setSelectedProfilesPolicySimulator } from "../../../../redux/selectedProfilesPolicySimulator";
import { getSelectedProfilesPolicySimulator } from "../../../../redux/selectedProfilesPolicySimulator";

export default function CustomProfilesPolicySimulator(props) {
    const { profiles, onProfileChanged, onSelectedProfile, onSaveProfile, nodes, handleEditProfile, handleDeleteProfile, runSimulatePolicy } = props;

    const dispatch = useDispatch();

    const selectedProfileSimulate = useSelector(getSelectedProfileSimulate);
    const selectedProfiles = useSelector(getSelectedProfilesPolicySimulator);
    const simulatorProfiles = useSelector(getSimulatorProfiles);

    const [originalProfiles, setOriginalProfiles] = useState([]);
    const [draftProfiles, setDraftProfiles] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    // const [isModified, setIsModified] = useState(false);
    const [modifiedItems, setModifiedItems] = useState({});
    const [expandedItems, setExpandedItems] = useState([]);
    const [profileEdit, setProfileEdit] = useState();
    // const regulatoryFile = useSelector(getRegulatoryFile);

    const onProfileSelected = (event, itemId, isSelected) => {
        const selectedProfile = draftProfiles.find((profile) => `${profile?.id}` === `${itemId}`);
        if (!selectedProfile) {
            return;
        }

        const currentSelected = Array.isArray(selectedProfiles) ? selectedProfiles : [];
        const hasProfile = currentSelected.some((profile) => `${profile?.id || ''}` === `${selectedProfile?.id || ''}`);
        let nextSelectedProfiles = currentSelected;

        if (isSelected && !hasProfile) {
            nextSelectedProfiles = [...currentSelected, selectedProfile];
        } else if (!isSelected && hasProfile) {
            nextSelectedProfiles = currentSelected.filter((profile) => `${profile?.id || ''}` !== `${selectedProfile?.id || ''}`);
        }

        const sorted = sortByCreatedAt(nextSelectedProfiles);
        // console.log("sorted profiles", sorted);

        dispatch(setSelectedProfilesPolicySimulator(sorted));

        if (nextSelectedProfiles.length === 0) {
            dispatch(setSelectedProfileSimulate(null));
            return;
        }

        // const focusIndex = isSelected
        //     ? selectedIndex
        //     : nextSelectedIndexes[nextSelectedIndexes.length - 1];
        // dispatch(setSelectedProfileSimulate(draftProfiles[focusIndex] || null));
    };

    const handleExpandedItemsChange = (event, itemIds) => {
        const newlyExpanded = itemIds.filter((id) => !expandedItems.includes(id));

        if (newlyExpanded.length > 0) {
            // ถ้ามีการกางอันใหม่ ให้บังคับเซ็ต State ให้มีแค่ ID ใหม่ตัวเดียว (ทำให้ตัวเก่าหุบทันที)
            setExpandedItems([newlyExpanded[0]]);
        } else {
            // ถ้าเป็นการคลิกเพื่อหุบตัวมันเอง (itemIds จะว่าง) ก็เซ็ตตามปกติ
            setExpandedItems(itemIds);
        }
    };

    const getAttributeValueType = (profileIndex, attrKey, attrValue) => {
        if (Array.isArray(attrValue)) {
            return 'array';
        }

        const originalValue = originalProfiles?.[profileIndex]?.attributes?.[attrKey];
        if (typeof originalValue === 'number') {
            return 'number';
        }

        return typeof attrValue;
    };

    const normalizeNumberValueForSave = (value) => {
        if (value === '' || value === null || value === undefined || value === '-' || value === '.' || value === '-.') {
            return null;
        }

        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const handleValueChange = (profileIndex, attrKey, newValue) => {
        let newDrafts = [...draftProfiles];
        newDrafts[profileIndex] = {
            ...newDrafts[profileIndex],
            attributes: {
                ...newDrafts[profileIndex].attributes,
                [attrKey]: newValue
            }
        };
        const is_modified = JSON.stringify(newDrafts[profileIndex]) !== JSON.stringify(originalProfiles[profileIndex]);
        if (is_modified !== modifiedItems[profileIndex]) {
            onProfileChanged(is_modified);
        }
        // setIsModified(is_modified);
        setModifiedItems((prev) => ({ ...prev, [profileIndex]: is_modified }));
        setDraftProfiles(newDrafts);
    };

    const handleMoreClick = (event, item) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setProfileEdit(item);
    };

    const onClose = () => {
        setAnchorEl(null);
    };

    const onClickMenu = (action) => {
        setAnchorEl(null);
        if (action === 'edit') {
            handleEditProfile(profileEdit);
        } else if (action === 'delete') {
            handleDeleteProfile(profileEdit);
        }
    }

    const handleSave = (e, index) => {
        e.stopPropagation();
        onProfileChanged(false);
        setModifiedItems((prev) => ({ ...prev, [index]: false }));
        const normalizedAttributes = Object.entries(draftProfiles[index]?.attributes || {}).reduce((acc, [attrKey, attrValue]) => {
            const attrType = getAttributeValueType(index, attrKey, attrValue);
            acc[attrKey] = attrType === 'number' ? normalizeNumberValueForSave(attrValue) : attrValue;
            return acc;
        }, {});

        const updatedProfile = {
            ...draftProfiles[index],
            attributes: normalizedAttributes,
            updated_at: new Date().toISOString()
        };
        if (onSaveProfile) {
            onSaveProfile(updatedProfile);
        }
        setDraftProfiles((prev) => {
            let next = [...prev];
            next[index] = updatedProfile;
            return next;
        });
        setOriginalProfiles((prev) => {
            let next = [...prev];
            next[index] = updatedProfile;
            return next;
        });
    };

    const handleDiscard = (e, index) => {
        e.stopPropagation();
        onProfileChanged(false);
        setModifiedItems((prev) => ({ ...prev, [index]: false }));
        let newDrafts = [...draftProfiles];
        newDrafts[index] = originalProfiles[index];
        setDraftProfiles(newDrafts);
    };

    const selectedProfileItemIds = (Array.isArray(selectedProfiles) ? selectedProfiles : [])
        .map((profile) => profile?.id)
        .filter(Boolean)
        .map((id) => `${id}`);

    const sortByCreatedAt = (arr) => {
        return [...arr].sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
        });
    }

    useEffect(() => {
        // console.log("simulatorProfiles", simulatorProfiles);

        const updateAttributes = (obj1, obj2) => {
            const updatedObj1 = { ...obj1 };
            const attributes1 = { ...obj1.attributes };
            const attributes2 = obj2.attributes || {};

            // วนลูปเช็คทุก key ใน attributes ของ obj1
            Object.keys(attributes1).forEach((key) => {
                // ถ้า key นี้มีอยู่ใน obj2.attributes ด้วย -> แทนที่ value
                if (Object.prototype.hasOwnProperty.call(attributes2, key)) {
                    attributes1[key] = attributes2[key];
                }
            });

            return attributes1;
        }

        if (simulatorProfiles && simulatorProfiles.length > 0 && selectedProfiles && selectedProfiles.length > 0) {
            const updatedAttributes = selectedProfiles.map((profile) => {
                const originalProfile = simulatorProfiles.find((p) => p.id === profile.id);
                if (originalProfile) {
                    const updatedAttributes = updateAttributes(profile, originalProfile);
                    return {
                        ...originalProfile,
                        attributes: updatedAttributes,
                    }
                }
                return profile;
            });
            const sorted = sortByCreatedAt(updatedAttributes);
            dispatch(setSelectedProfilesPolicySimulator(sorted));
        }
    }, [simulatorProfiles]);

    useEffect(() => {
        if (profiles) {
            setOriginalProfiles(profiles);
            setDraftProfiles(profiles);
        }
    }, [profiles]);

    useEffect(() => {
        const currentSelected = Array.isArray(selectedProfiles) ? selectedProfiles : [];
        if (currentSelected.length === 0) {
            return;
        }

        const draftById = new Map(draftProfiles.map((profile) => [`${profile?.id || ''}`, profile]));
        const validSelected = currentSelected
            .map((profile) => {
                const profileId = `${profile?.id || ''}`;
                return draftById.get(profileId) || null;
            })
            .filter(Boolean);

        const hasSameIds =
            validSelected.length === currentSelected.length &&
            validSelected.every((profile, index) => `${profile?.id || ''}` === `${currentSelected[index]?.id || ''}`);

        if (!hasSameIds) {
            const sorted = sortByCreatedAt(validSelected);
            dispatch(setSelectedProfilesPolicySimulator(sorted));
            if (validSelected.length === 0) {
                dispatch(setSelectedProfileSimulate(null));
            }
        }
    }, [draftProfiles, dispatch, selectedProfiles]);

    return (
        <SimpleTreeView
            onItemSelectionToggle={onProfileSelected}
            selectedItems={selectedProfileItemIds}
            expandedItems={expandedItems}
            onExpandedItemsChange={handleExpandedItemsChange}
            checkboxSelection
            multiSelect
            sx={{
                '& .MuiCheckbox-root': {
                    p: 0.25,
                },
                '& .MuiCheckbox-root .MuiSvgIcon-root': {
                    fontSize: 18,
                },
            }}
        >
            {draftProfiles.map((profile, index) => {
                const profileId = `${profile.id}`;
                const isCurrentItemModified = !!modifiedItems[index];
                const isSelectedProfile = selectedProfileSimulate?.id === profileId;
                const isRunDisabled = isCurrentItemModified || !isSelectedProfile;
                return (
                    <TreeItem
                        key={profileId}
                        itemId={profileId}
                        sx={{
                            [`& .MuiTreeItem-content`]: {
                                borderRadius: 0,
                                height: '40px',
                                padding: 0,
                                paddingLeft: '10px',
                                paddingRight: '2px',
                                borderBottom: '1px solid #ccc',
                                // borderTop: index === 0 ? '1px solid #ccc' : 'none',
                                borderTop: '1px solid #ccc',
                            },
                            [`& .MuiTreeItem-content.Mui-selected`]: {
                                backgroundColor: 'transparent !important',
                            },
                            [`& .MuiTreeItem-content.Mui-selected:hover`]: {
                                backgroundColor: 'transparent !important',
                            },
                            [`& .MuiTreeItem-content.Mui-focused`]: {
                                backgroundColor: 'transparent !important',
                            },
                            [`& .MuiTreeItem-content:hover`]: {
                                backgroundColor: 'transparent !important',
                            },
                        }}
                        label={
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    py: 1,
                                    width: '100%',
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 600 }}
                                // fontSize="medium"
                                >
                                    {profile.name}{' '}
                                </Typography>

                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Fade in={isCurrentItemModified} timeout={{ enter: 200, exit: 150 }} unmountOnExit>
                                        <Box sx={{ display: 'flex' }}>
                                            <IconButton
                                                aria-label="save"
                                                size="small"
                                                color="info"
                                                onClick={(e) => handleSave(e, index)}
                                            >
                                                <SaveIcon fontSize="inherit" />
                                            </IconButton>
                                            <IconButton
                                                aria-label="Discard"
                                                size="small"
                                                color="inherit"
                                                onClick={(e) => handleDiscard(e, index)}
                                            >
                                                <DoDisturbIcon fontSize="inherit" />
                                            </IconButton>
                                        </Box>
                                    </Fade>
                                    {/* <div
                                        className={`flex justify-center items-center pl-1.5 rounded-full ${isRunDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 cursor-pointer'}`}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <Typography variant='button' fontSize={10} className='text-white' marginTop="2px">
                                            Run
                                        </Typography>
                                        <PlayCircleFilledWhiteIcon
                                            // className={`p-0.5`}
                                            color="white"
                                            sx={{ fontSize: 18, alignItems: 'center', padding: '1px' }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (isRunDisabled) return;
                                                runSimulatePolicy(profile);
                                            }}
                                        />
                                    </div> */}
                                    {/* <IconButton
                                        size="small"
                                        onClick={(e) => handleMoreClick(e, profile)}
                                        sx={{ '&:hover': { color: 'primary.main' } }}
                                    >
                                        <MoreVertIcon fontSize="inherit" />
                                    </IconButton> */}
                                </Box>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 1, px: 0 }}>
                            {Object.entries(profile.attributes).map(
                                ([attrKey, attrValue]) => {
                                    const valueType = getAttributeValueType(index, attrKey, attrValue);
                                    const isArray = valueType === 'array';
                                    const fieldId = `${profileId}-${attrKey}`;

                                    return (
                                        <Box
                                            key={fieldId}
                                            // itemId={fieldId}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                px: 1,
                                                ml: 3,
                                                mr: 0.5
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: 'text.secondary',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {attrKey}:
                                            </Typography>

                                            {/* กรณี Array: ใช้ Autocomplete Multiple FreeSolo */}
                                            {isArray ? (
                                                <Autocomplete
                                                    multiple
                                                    freeSolo
                                                    size='small'
                                                    options={[]} // ไม่มี predefined options ให้พิมพ์เอาเอง
                                                    value={attrValue}
                                                    onChange={(event, newValue) =>
                                                        handleValueChange(index, attrKey, newValue)
                                                    }
                                                    renderValue={(tagValue, getTagProps) =>
                                                        tagValue.map((option, index) => {
                                                            const { key, ...tagProps } = getTagProps({ index });
                                                            return (
                                                                <Chip
                                                                    label={option}
                                                                    key={key}
                                                                    {...tagProps}
                                                                    size="small"
                                                                    variant="outlined"
                                                                />
                                                            )
                                                        })
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Add items..."
                                                            onClick={(e) => e.stopPropagation()}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                            onKeyDown={(e) => e.stopPropagation()}
                                                            sx={{
                                                                width: '100%',
                                                                fontSize: 12,
                                                                '& .MuiInputBase-input': {
                                                                    padding: '0px 6px',
                                                                    height: '28px',
                                                                },
                                                                '& .MuiInputBase-input::placeholder': {
                                                                    fontSize: '12px',
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    sx={{ flexGrow: 1, width: 100 }}
                                                />
                                            ) : valueType === 'boolean' ? (
                                                <Switch
                                                    size="small"
                                                    checked={attrValue}
                                                    onChange={(e) =>
                                                        handleValueChange(index, attrKey, e.target.checked)
                                                    }
                                                />
                                            ) : (
                                                <TextField
                                                    size="small"
                                                    variant="outlined"
                                                    type={valueType === 'number' ? 'text' : undefined}
                                                    value={attrValue ?? ''}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onMouseDown={(e) => e.stopPropagation()}
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        if (valueType === 'number') {
                                                            const numericTypingPattern = /^-?\d*\.?\d*$/;
                                                            if (!numericTypingPattern.test(val)) {
                                                                return;
                                                            }
                                                        }
                                                        handleValueChange(index, attrKey, val);
                                                    }}
                                                    sx={{
                                                        width: '100%',
                                                        flex: 1,
                                                        '& .MuiInputBase-root': {
                                                            height: '28px',
                                                            fontSize: 12,
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            padding: '0px 6px',
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    );
                                }
                            )}
                        </Box>
                    </TreeItem>
                );
            })}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={() => onClickMenu('edit')}>Edit</MenuItem>
                <MenuItem onClick={() => onClickMenu('delete')}>Delete</MenuItem>
            </Menu>
        </SimpleTreeView>
    );
}